<template>
  <div>
    <home-replace-banner></home-replace-banner>
    <home-strength-intro
      :imgurl=serviceGuarantee
      :isSecond=false
      slogan="服务保障"
      description="7*24全天候服务，资深木材行业服务工程师提供一对一服务。"></home-strength-intro>
    <home-strength-intro
      :imgurl=serviceSpot
      :isSecond=true
      slogan="服务站点"
      description="满洲里、二连浩特、天津、青岛等货源口岸建立站点，服务商家。"></home-strength-intro>
    <home-strength-intro
      :imgurl=sourceGuarantee
      :isSecond=false
      slogan="货源保障"
      description="严格根据商家需求，货场直接查找货源，提供真实商品信息。"></home-strength-intro>
    <home-strength-intro
      :imgurl=processVisualization
      :isSecond=true
      slogan="流程可视化"
      description="从需求、货源鉴定、付款、装车、发货等全流程实时汇报。"></home-strength-intro>
  </div>
</template>

<script>
  import HomeStrengthIntro from '../HomeServiceIntro.vue'
  import HomeReplaceBanner from './HomeReplaceBanner'
  export default {
    name: 'HomeMortgageContent',
    components: {
      HomeReplaceBanner, HomeStrengthIntro
    },
    data () {
      return {
        serviceGuarantee: '/static/img/service_intro/replace/service-guarantee.png',
        serviceSpot: '/static/img/service_intro/replace/service-spot.png',
        sourceGuarantee: '/static/img/service_intro/replace/source-guarantee.png',
        processVisualization: '/static/img/service_intro/replace/process-visualization.png'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// HomeReplaceContent.vue?22c85dc1